import { useState } from "react";
import {
  PasswordHide,
  PasswordView,
} from "../../../utility/constants/assetsManager";
import { colorWhite } from "../../../utility/constants/colorManager";
import { CustomInput } from "../main_comps/custom_input/CustomInput";

const CustomPasswordInput = ({
  value,
  onChange,
  placeholder,
  isError,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <div
        style={{
          position: "relative",
          margin: 0,
          padding: 0,
          backgroundColor: colorWhite,
          border: `1px solid #E8E8E8`,
          width: "100%",
          outline: "none",
          borderRadius: 5,
          boxSizing: "border-box",
          fontSize: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "45px",
        }}
      >
        <CustomInput
          type="input"
          validator="password"
          placeholder={placeholder}
          onChange={(val) => {
            let reg = new RegExp(
              "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,16})"
            );
            if (reg.test(val) && val.length <= 16) {
              isError(true);
            } else {
              isError(false);
            }

            if (val === "") {
            }
            onChange(val);
          }}
          isPassword={!showPassword}
          value={value}
          maxLength={16}
          inputStyles={{
            width: "100%",
            border: "0px solid #E8E8E8",
            boxShadow: "none",
            height: "30px",
            backgroundColor: "white",
          }}
          autoComplete={autoComplete}
        />

        {showPassword ? (
          <img
            src={PasswordHide}
            onClick={() => {
              setShowPassword(false);
            }}
            style={{
              cursor: "pointer",
              position: "absolute",
              right: 10,
              zIndex: 10,
            }}
          />
        ) : (
          <img
            src={PasswordView}
            onClick={() => {
              setShowPassword(true);
            }}
            style={{
              cursor: "pointer",
              position: "absolute",
              right: 10,
              zIndex: 10,
            }}
          />
        )}
      </div>
    </>
  );
};

export default CustomPasswordInput;
